import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image, Anchor } from "hesus-ui-kit";
import DocumentPreview from "../../Document/DocumentPreview/DocumentPreview";
import {
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  ReportWrapper,
  ReportTitleText,
  WrapperStatus,
  WrapperStatusDate,
  ReportWrapperSummary,
  WrapperSubTitle,
  ButtonContainer,
  ButtonData,
  ReportTitleValue,
  DocumentRow,
  DocumentInfo,
  DocumentWrppaer,
  ButtonAttendeesContainer,
  DocumentName,
} from "./MeetingReportView.styled";
import "./MeetingReportView.scss";
import dotIcon from "@icons/ic-dot-navy-blue.svg";
import { Rating } from "../MeetingReportsList/components/Rating/Rating";

const MeetingReportView = (props) => {
  const { t, meetingReportInfo } = props;
  const [selectedDocument, setSelectedDocument] = useState(null);

  const openPreview = (document) => setSelectedDocument(document);
  const closePreview = () => setSelectedDocument(null);

  return (
    <>
      <FormBody>
        <OptionsWrapper>
          <FlexRow>
            <SectionContainer>
              <ReportWrapper>
                <ReportTitleText>{meetingReportInfo.title}</ReportTitleText>
                <WrapperStatusDate>
                  {meetingReportInfo.meetingDate}
                </WrapperStatusDate>
              </ReportWrapper>
              <ReportWrapperSummary>
                <ReportTitleText>{t("MEETING_SUMMARY")}</ReportTitleText>
                <ReportWrapper>
                  <WrapperSubTitle>{t("HESUS_PARTICIPANTS")}</WrapperSubTitle>
                  <WrapperSubTitle>{t("ENTITES_LINKED")}</WrapperSubTitle>
                </ReportWrapper>
                <ReportWrapper>
                  <WrapperStatus>
                    <ButtonAttendeesContainer>
                      {meetingReportInfo.attendees.map((admins) => {
                        return (
                          <ButtonData key={admins.id}>
                            {admins.firstName} {admins.lastName}
                          </ButtonData>
                        );
                      })}
                    </ButtonAttendeesContainer>
                  </WrapperStatus>
                  <WrapperStatus>
                    <ButtonContainer>
                      {meetingReportInfo.linkedEntities.companies.map(
                        (company) => {
                          return (
                            <Anchor
                              url={`/company/view/${company.id}/general-info`}
                              target="_blank"
                              rel="noreferrer"
                              key={company.id}
                            >
                              <ButtonData>
                                #{company.id} -{company.name}
                              </ButtonData>
                            </Anchor>
                          );
                        }
                      )}
                      {meetingReportInfo.linkedEntities.contacts.map(
                        (contact) => {
                          return (
                            <Anchor
                              url={`/user/classic/view/${contact.id}/contact`}
                              target="_blank"
                              rel="noreferrer"
                              key={contact.id}
                            >
                              <ButtonData>
                                #{contact.id} - {contact.name}
                              </ButtonData>
                            </Anchor>
                          );
                        }
                      )}
                      {meetingReportInfo.linkedEntities.sites.map((site) => {
                        return (
                          <Anchor
                            url={`/site/view/${site.id}/general-info`}
                            target="_blank"
                            rel="noreferrer"
                            key={site.id}
                          >
                            <ButtonData>
                              #{site.id} - {site.name}
                            </ButtonData>
                          </Anchor>
                        );
                      })}
                    </ButtonContainer>
                  </WrapperStatus>
                </ReportWrapper>
                <ReportWrapper>
                  <WrapperSubTitle>{t("DESCRIPTION")}</WrapperSubTitle>
                </ReportWrapper>
                <ReportTitleValue>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: meetingReportInfo.description,
                    }}
                  ></div>
                </ReportTitleValue>
                <ReportWrapper>
                  <WrapperSubTitle>{t("DOCUMENTS")}</WrapperSubTitle>
                  <WrapperSubTitle>{t("RATING")}</WrapperSubTitle>
                </ReportWrapper>
                <ReportWrapper>
                  <WrapperStatus>
                    {meetingReportInfo.documents.length > 0 && (
                      <DocumentWrppaer>
                        {meetingReportInfo.documents.map((document) => {
                          return (
                            <DocumentRow key={document.id}>
                              <DocumentInfo>
                                <DocumentName
                                  onClick={() => openPreview(document)}
                                  className="meeting-reports-view__document-link"
                                >
                                  <Image
                                    className="deleteImage"
                                    src={dotIcon}
                                    alt="delete"
                                    onClick={() => deleteFile(i)}
                                    styles={{ marginRight: "6px" }}
                                  />
                                  {document.fileName}
                                </DocumentName>
                              </DocumentInfo>
                            </DocumentRow>
                          );
                        })}
                      </DocumentWrppaer>
                    )}
                  </WrapperStatus>
                  <WrapperStatus>
                    <Rating rating={meetingReportInfo.rating} />
                  </WrapperStatus>
                </ReportWrapper>
              </ReportWrapperSummary>
              <ReportWrapperSummary>
                <ReportTitleText>{t("NEXT_STEPS")} </ReportTitleText>
                <ReportWrapper>
                  <WrapperSubTitle>{t("MEETING_NEXT_DATE")}</WrapperSubTitle>
                  <ReportTitleValue>
                    {meetingReportInfo.nextStepDate}
                  </ReportTitleValue>
                </ReportWrapper>
                <ReportWrapper>
                  <WrapperSubTitle>{t("NEXT_STEP")}</WrapperSubTitle>
                </ReportWrapper>
                <ReportTitleValue>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: meetingReportInfo.nextStepDescription,
                    }}
                  ></div>
                </ReportTitleValue>
              </ReportWrapperSummary>
            </SectionContainer>
          </FlexRow>
        </OptionsWrapper>
      </FormBody>
      {selectedDocument && (
        <DocumentPreview document={selectedDocument} onClose={closePreview} />
      )}
    </>
  );
};

MeetingReportView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(MeetingReportView);
